import { GET_QUESTIONS } from "../../@jumbo/constants/ActionTypes";

const INIT_STATE = {
    questions: [],
    isLoadedQuestions: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_QUESTIONS: {
            return {
                ...state,
                questions: action.payload,
                isLoadedQuestions: true
            };
        }
        default:
            return state;
    }
};
